<script>
import {createHOC} from 'vue-hoc'
import {queryDictionaryDetails} from '@/api/admin/cp'
import Base from '../../zpa/form/radio-group'

const options = {
  name: 'DictionaryRadio',

  props: {
    code: {
      type: String,
      required: true,
    },
  },
}

const renderWith = {
  props: {
    query() {
      if (this.code) {
        return () => queryDictionaryDetails(this.code)
      }
    },
    valueField: 'dataCode',
    textField: 'dataValue',
  },
}

export default createHOC(Base, options, renderWith)
</script>
